import { c as _c } from "react/compiler-runtime";
import type { ChatEmoticonItem } from '@module/apis/client-side/chat-emoticon/type';
import { cn } from '@module/lib/utils';
import CloseMdIcon from '../icons/components/CloseMd';
interface Props {
  onClose: () => void;
  selectedBlockEmoticon: ChatEmoticonItem | null;
  className?: string;
  imgClassName?: string;
}
function ChatEmoticonSelectPreview(t0) {
  const $ = _c(18);
  const {
    onClose,
    selectedBlockEmoticon,
    className,
    imgClassName
  } = t0;
  if (!selectedBlockEmoticon) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("-top-[132px] absolute left-0 z-20 flex h-[132px] w-full items-center justify-between bg-system-tooltip-bg px-5 py-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== imgClassName) {
    t3 = cn("h-[90px] w-[100px]", imgClassName);
    $[3] = imgClassName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = selectedBlockEmoticon.anim || selectedBlockEmoticon.img;
  let t5;
  if ($[5] !== selectedBlockEmoticon.name || $[6] !== t4) {
    t5 = <img src={t4} alt={selectedBlockEmoticon.name} />;
    $[5] = selectedBlockEmoticon.name;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CloseMdIcon className="text-white" width={24} height={24} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onClose) {
    t8 = <div className="h-full"><button type="button" className="w-5" onClick={onClose}>{t7}</button></div>;
    $[12] = onClose;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t1 || $[15] !== t6 || $[16] !== t8) {
    t9 = <div id="chat-emoticon-select-preview" className={t1}>{t2}{t6}{t8}</div>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
export default ChatEmoticonSelectPreview;